import { Injectable, EventEmitter, Output } from '@angular/core';
import { ErrorObject } from './gpiserror-object'
import { ErrorTypeEnum } from '../shared/enums.model';

@Injectable()
export class ErrorHandlerService {
    @Output() errorEvent: EventEmitter<ErrorObject>;
    private errorObj: ErrorObject; 

    constructor() {
        this.errorEvent = new EventEmitter<ErrorObject>();
    }

    public getError(): ErrorObject {
        return this.errorObj;
    }

    public emitErrorObject( error: ErrorObject ): void {
        this.errorObj = error;
        this.errorEvent.emit( this.errorObj );
    }

    public emitError( errorText: string, originator: string, errorType: ErrorTypeEnum ): void {
        let eObj: ErrorObject = new ErrorObject( errorText, originator, errorType )
        this.emitErrorObject ( eObj );
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/errorhandler/gpiserror-handler.service.ts